import {
  CcfBox,
  CcfHeader,
  CcfWorkHistoryIcon,
  useTranslator,
} from '@nice-ccf/ui-controls';
import classes from './ccf-contact-history.module.scss';
import { useSelector } from 'react-redux';
import { getApplicationDirection, isPageReloaded } from '../global.app.slice';
import { Direction, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material';
import CcfContactHistoryTable from './ccf-contact-history-table/ccf-contact-history-table';
import CcfContactHistoryCard from './ccf-contact-history-card/ccf-contact-history-card';
import { contactHistoryListData } from './mock-data/contact-history-mock-data';
import { useEffect, useRef, useState } from 'react';

/* eslint-disable-next-line */
export interface CcfContactHistoryProps {
  isAppSpace: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    contactHistoryCard: {
      width: '100%',
      height: '100%',
      background: `${theme.palette.background.light} 0% 0% no-repeat padding-box`,
      boxShadow: `0px 1px 3px ${theme.palette.boxshadow.main}`,
      border: `1px solid ${theme.palette.border.main}`,
      [theme.breakpoints.up('xl')]: {
        borderRadius: '6px',
      },
      opacity: 1,
      marginRight: '12px',
      transition: 'all 0.5s ease',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
      '& .MuiOutlinedInput-input': {
        ...theme.typography.h4,
      },
    },
    contactHistoryHeader: {
      background: `${theme.palette.background.level1} 0% 0% no-repeat padding-box`,
      borderRadius: '5px 5px 0px 0px',
      opacity: 1,
      display: 'flex',
      alignItems: 'center',
      paddingTop: '10px',
      paddingBottom: '10px',
      paddingLeft: '5px',
      marginTop: '0px !important',
      '& section': {
        marginBottom: '0px !important',
        alignItems: 'center',
      },
      '& > div': {
        marginTop: '0px !important',
      },
      '& label': {
        color: theme.palette.text.secondary,
        marginLeft: '4px !important',
        marginTop: '0px !important',
        fontWeight: 'bold',
        lineHeight: '1',
      },
      '& svg': {
        verticalAlign: 'middle',
      },
    },
  })
);

/**
 * used to show contact history tab in left navigation
 * @param props - CcfContactHistoryProps
 * @example ` <CcfContactHistory />`
 */
export function CcfContactHistory(props: CcfContactHistoryProps) {
  const styles = useStyles();
  const theme = useTheme();
  const [translate] = useTranslator();
  const isPageReload = useSelector(isPageReloaded);
  const appDirection: Direction = useSelector(getApplicationDirection);
  const [contactHistoryData, setContactHistoryData] = useState(
    contactHistoryListData
  );
  const contactHistoryLocalStorage = useRef(
    JSON.parse(localStorage.getItem('contactHistoryLS') || '[]')
  );

  useEffect(() => {
    if (contactHistoryLocalStorage.current.length > 0) {
      setContactHistoryData(contactHistoryLocalStorage.current);
    } else {
      localStorage.setItem(
        'contactHistoryLS',
        JSON.stringify(contactHistoryListData)
      );
    }
  }, [contactHistoryLocalStorage.current]);

  return (
    <section className={styles.contactHistoryCard}>
      <CcfBox className={styles.contactHistoryHeader}>
        <CcfHeader
          LeftIcon={
            <CcfWorkHistoryIcon
              color="primary"
              viewBox="-2 -2 23 23"
              fontSize="small"
            />
          }
          headerText={translate('contactCardHistory')}
          direction={appDirection}
        />
      </CcfBox>
      <CcfBox
        className={
          props.isAppSpace
            ? classes.cardcontainerAppSpace
            : classes.cardcontainer
        }
      >
        {contactHistoryData.map((contact: any, index: any) => (
          <CcfContactHistoryCard key={contact.id} contact={contact} />
        ))}
        {/* <CcfContactHistoryTable isAppSpace={props.isAppSpace} /> */}
      </CcfBox>
    </section>
  );
}

export default CcfContactHistory;
